define('modules/accounts/status/products/mdirector/balance/view',['require','exports','module','views/BaseView','jquery','./transfer/index','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView");
  var $ = require("jquery");

  var Transfer = require("./transfer/index");

  var View = BaseView.extend({
    template: require("ldsh!./template"),
    transferModel: null,

    events: {
      "click #transferCredit": "initModalForm",
    },

    initialize: function () {
      if (this.model) {
        this.listenTo(this.model, "sync request error", this.render);
      }
    },

    afterRender: function () {
      $(".ayuda-context").popover();
      this.updateAccountList();
    },

    serialize: function () {
      return {
        group: this.group,
        model: this.model,
      };
    },

    initModalForm: function () {
      this.transferModel = new Transfer.TransferModel();
      var transferFormView = new Transfer.TransferFormView({
        el: "#transfer-modal-body",
        balance: this.model,
        model: this.transferModel,
        group: this.group,
      });
      transferFormView.render();
    },

    updateAccountList: function () {
      var self = this;
      $("#new-transfer-modal").on("hidden.bs.modal", function () {
        if (self.model && self.transferModel) {
          self.model.fetch();
        }
      });
    },
  });

  module.exports = View;
});

